unit Menu;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls,WebLib.JSON,
  WEBLib.StdCtrls,System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage;
//   FireDAC.Stan.Intf, FireDAC.Stan.Option;
//  FireDAC.Stan.Error, FireDAC.UI.Intf, FireDAC.Phys.Intf, FireDAC.Stan.Def,
//  FireDAC.Stan.Pool, FireDAC.Stan.Async, FireDAC.Phys, FireDAC.VCLUI.Wait,
//  FireDAC.Stan.Param, FireDAC.DatS, FireDAC.DApt.Intf, FireDAC.DApt,
//  FireDAC.Comp.DataSet, FireDAC.Comp.Client;

type
  TFMenu = class(TForm)
    WebHttpRequest1: THttpRequest;
    ConSolicitudHdr: TClientConnection;
    TSolicitudHdr: TClientDataSet;
    DsSolicitudHdr: TDataSource;
    WebImageControl1: TImageControl;
    WebLabel2: TLabel;
    WebLabel24: TLabel;
    WPanel1: TPanel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebButton2: TButton;
    EditUsuario: TEdit;
    EditClave: TEdit;
    WPanel2: TPanel;
    WebLabel1: TLabel;
    WebLabel5: TLabel;
    WebLabel20: TLabel;
    WebSpeedButton1: TSpeedButton;
    WebPageControl1: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WPanel3: TPanel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebLabel30: TLabel;
    WebLabel31: TLabel;
    WebLabel10: TLabel;
    WebLabel13: TLabel;
    WebLabel32: TLabel;
    EditFolio: TDBEdit;
    EditFechaPedido: TDBEdit;
    EditNombre: TDBEdit;
    EditNombre2: TDBEdit;
    EditDepto: TDBEdit;
    EditDepto2: TDBEdit;
    EditDocumentoNombre: TDBEdit;
    EditRevision: TDBEdit;
    EditNoDocumento: TDBEdit;
    EditAlcance: TDBEdit;
    EditFechaFinalizada: TDBEdit;
    WebPanel1: TPanel;
    Empleados: TTabSheet;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    EditNumero: TDBEdit;
    EditOnClass: TDBEdit;
    EditOnDem: TDBEdit;
    EditOnJob: TDBEdit;
    EditOnVideo: TDBEdit;
    EditOnSemin: TDBEdit;
    EditOnSelf: TDBEdit;
    EditOnOther: TDBEdit;
    EditDuracion: TDBEdit;
    EditDuracionTotal: TDBEdit;
    EditBuscar: TEdit;
    WebLabel33: TLabel;
    WebDBGrid1: TDBGrid;
    WebTimer1: TTimer;
    WebDBGrid2: TDBGrid;
    ConSolicitudDET: TClientConnection;
    TSolicitudDet: TClientDataSet;
    DsSolicitudDet: TDataSource;
    WebDateTimePicker1: TDateTimePicker;
    WebDateTimePicker2: TDateTimePicker;
    EditEmpPaterno: TDBEdit;
    EditEmpMaterno: TDBEdit;
    EditEmpNombre: TDBEdit;
    WebTimer2: TTimer;
    WebLabel23: TLabel;
    EditPuesto: TDBEdit;
    EditPuestoNombre: TDBEdit;
    WebLabel34: TLabel;
    EditFolioD: TDBEdit;
    ConEmpleados: TClientConnection;
    TEmpleados: TClientDataSet;
    DSEmpleados: TDataSource;
    ConUsuarios: TClientConnection;
    TUsuarios: TClientDataSet;
    WebLabel35: TLabel;
    WebSpeedButton2: TSpeedButton;
    WebImageControl2: TImageControl;
    ConPuestos: TClientConnection;
    TPuestos: TClientDataSet;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    WebSpeedButton13: TSpeedButton;
    WebSpeedButton14: TSpeedButton;
    WebLabel36: TLabel;
    EditFolioi: TEdit;
    WebSpeedButton15: TSpeedButton;
    WebSpeedButton16: TSpeedButton;
    WebSpeedButton17: TSpeedButton;
    WebSpeedButton18: TSpeedButton;
    WebSpeedButton19: TSpeedButton;
    WebLabel37: TLabel;
    WebLabel19: TLabel;
    WebLabel38: TLabel;
    procedure WebButton2Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton7Click(Sender: TObject);
    procedure WebButton4Click(Sender: TObject);
    procedure WebTimer1Timer(Sender: TObject);
    procedure WebButton9Click(Sender: TObject);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure EditFechaPedidoEnter(Sender: TObject);
    procedure WebDateTimePicker1Exit(Sender: TObject);
    procedure EditFechaFinalizadaEnter(Sender: TObject);
    procedure WebDateTimePicker2Exit(Sender: TObject);
    procedure WebTimer2Timer(Sender: TObject);
    procedure TSolicitudHdrCalcFields(DataSet: TDataSet);
    procedure EmpleadosShow(Sender: TObject);
    procedure WebButton19Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebSpeedButton14Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton15Click(Sender: TObject);
    procedure WebSpeedButton16Click(Sender: TObject);
    procedure WebSpeedButton17Click(Sender: TObject);
    procedure WebSpeedButton13Click(Sender: TObject);
  private
    { Private declarations }
    Procedure ActivaCapturaHdr;
    Procedure DesActivaCapturaHdr;
    Procedure ActivaCapturaDet;
    Procedure DesActivaCapturaDet;
    Procedure AgregaHdr;
    Procedure ModificaHdr;
    Procedure AgregaDet;
    Procedure ModificaDet;
    Procedure FiltraDet;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

type
  TProcedureRef = reference to procedure;

var
  FMenu: TFMenu;
  BanderaIn,MBandera,Mllave:String;
  Ano,Mes,Dia:Word;
  ValoresLocate: array of JSValue;
implementation

{$R *.dfm}

// === Codificar un string a Base64 ===
function Base64Encode(const S: string): string;
begin
  asm
    try {
      // btoa solo soporta Latin-1 → convertimos a UTF-8 antes
      Result = btoa(unescape(encodeURIComponent(S)));
    } catch(e) {
      console.error("Base64Encode error:", e);
      Result = "";
    }
  end;

end;

// === Decodificar un Base64 a string ===
function Base64Decode(const S: string): string;
begin
  asm
    try {
      // atob → UTF-8
      Result = decodeURIComponent(escape(atob(S)));
    } catch(e) {
      console.error("Base64Decode error:", e);
      Result = "";
    }
  end;

end;


procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
      AProc();
    }, Milliseconds);
  end;
end;

procedure TFMenu.WebButton19Click(Sender: TObject);
begin
end;

//// Procedimiento para agragar registros a la tabla solicitudHdr
///// encabezado del documento
procedure TFMenu.AgregaHdr;
var
  Data: TJSONObject;
begin
if TSolicitudHdr.Locate('Folio', EditFolio.Text, []) then
  Begin
  ShowMessage('Error Documento Duplicado !!!!');
  MBandera:='';
  Exit;
  End;

//if TSolicitudHdr.Locate('Folio',EditFolio.Text,[]) Then
//  ShowMessage('Folio!!!1');
if EditNoDocumento.Text=''  then EditNoDocumento.Text:='0';
if EditFolio.Text=''  then EditFolio.Text:='0';


Data := TJSONObject.Create;
  try
    Data.AddPair('Folio', EditFolio.Text);
    Data.AddPair('Nombre', EditNombre.Text);
    Data.AddPair('Nombre2', EditNombre2.Text);
    Data.AddPair('NoDocumento', EditNodocumento.Text);
    if EditNodocumento.Text = '' then
      Data.AddPair('NoDocumento', '0');
    Data.AddPair('Alcance', EditAlcance.Text);
    Data.AddPair('Depto', EditDepto.Text);
    Data.AddPair('Depto2', EditDepto2.Text);
    Data.AddPair('Revision', EditRevision.Text);
    Data.AddPair('DocumentoNombre', EditDocumentoNombre.Text);
    Data.AddPair('FechaPedido', EditFechaPedido.Text);
    Data.AddPair('Duracion', EditDuracion.Text);
    Data.AddPair('DuracionTotal', EditDuracionTotal.Text);
    Data.AddPair('FechaFinalizada', EditFechaFinalizada.Text);
    Data.AddPair('OnClass', EditOnClass.Text);
    Data.AddPair('OnDem', EditOnDem.Text);
    Data.AddPair('OnJob', EditOnJob.Text);
    Data.AddPair('OnVideo', EditOnVideo.Text);
    Data.AddPair('OnSemin', EditOnSemin.Text);
    Data.AddPair('OnSelf', EditOnSelf.Text);
    Data.AddPair('OnOther', EditOnOther.Text);


    WebHttpRequest1.URL := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudHDR'; ///
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
DesActivaCapturaHdr;
MBandera:='';
End;

/// procedimiento para agregar registro nuevo de detalle de solicitud
///// tabla en donde se guardan los empleados
procedure TFMenu.AgregaDet;
var
  Data: TJSONObject;
begin
ValoresLocate[0]:=EditFolioD.Text;
ValoresLocate[1]:=EditNumero.Text;

if TSolicitudDet.Locate('Folio;Numero', ValoresLocate, [loCaseInsensitive]) then
  Begin
  ShowMessage('Error Numero de empleado Duplicado !!!!');
  MBandera:='';
  Exit;
  End;


Data := TJSONObject.Create;
  try
    Data.AddPair('Folio', EditFolioD.Text);
    Data.AddPair('Numero', EditNumero.Text);
    Data.AddPair('EmpPaterno', EditempPaterno.Text);
    Data.AddPair('EmpMaterno', EditEmpMaterno.Text);
    Data.AddPair('EmpNombre', EditEmpNombre.Text);
    Data.AddPair('Puesto', EditPuesto.Text);
    Data.AddPair('PuestoNombre', EditPuestoNombre.Text);


    WebHttpRequest1.URL := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudDET';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
DesActivaCapturaHdr;
MBandera:='';
End;

////// procedimiento para modificar un registro tabla solicitudHdr
//// tabla del encabezado
procedure TFMenu.ModificaHdr;
var
  Data: TJSONObject;
Begin
Data := TJSONObject.Create;
  try
//    Data.AddPair('POFolio', FloatToStr((Tempresa.FieldByName('POFolio').AsFloat + 1)));    Data.AddPair('POFolio', FloatToStr((Tempresa.FieldByName('POFolio').AsFloat + 1)));

    Data.AddPair('Folio', EditFolio.Text);
    Data.AddPair('Nombre', EditNombre.Text);
    Data.AddPair('Nombre2', EditNombre2.Text);
    Data.AddPair('NoDocumento', EditNodocumento.Text);
    Data.AddPair('Alcance', EditAlcance.Text);
    Data.AddPair('Depto', EditDepto.Text);
    Data.AddPair('Depto2', EditDepto2.Text);
    Data.AddPair('Revision', EditRevision.Text);
    Data.AddPair('DocumentoNombre', EditDocumentoNombre.Text);
    Data.AddPair('FechaPedido', EditFechaPedido.Text);
    Data.AddPair('Duracion', EditDuracion.Text);
    Data.AddPair('DuracionTotal', EditDuracionTotal.Text);
    Data.AddPair('FechaFinalizada', EditFechaFinalizada.Text);
    Data.AddPair('OnClass', EditOnClass.Text);
    Data.AddPair('OnDem', EditOnDem.Text);
    Data.AddPair('OnJob', EditOnJob.Text);
    Data.AddPair('OnVideo', EditOnVideo.Text);
    Data.AddPair('OnSemin', EditOnSemin.Text);
    Data.AddPair('OnSelf', EditOnSelf.Text);
    Data.AddPair('OnOther', EditOnOther.Text);


    WebHttpRequest1.URL := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudHDR';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPUT;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;
  finally
    Data.Free;
  end;
DesActivaCapturaHdr;
MBandera:='';
End;

procedure TFMenu.TSolicitudHdrCalcFields(DataSet: TDataSet);
begin
end;

//// procedimiento para modificar tabla solicitudesDet
//// tabla donde se guardan los empleados
procedure TFMenu.ModificaDet;
var
  Data: TJSONObject;
Begin
Data := TJSONObject.Create;
  try

    Data.AddPair('FolioD', EditFolio.Text);
    Data.AddPair('Numero', EditNumero.Text);
    Data.AddPair('EmpPaterno', EditEmpPaterno.Text);
    Data.AddPair('EmpMaterno', EditEmpMaterno.Text);
    Data.AddPair('EmpNombre', EditEmpNombre.Text);
    Data.AddPair('Puesto', EditPuesto.Text);
    Data.AddPair('PuestoNombre', EditPuestoNombre.Text);


    WebHttpRequest1.URL := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudDET';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPUT;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;
  finally
    Data.Free;
  end;
DesActivaCapturaDet;
MBandera:='';
End;

procedure TFMenu.WebButton1Click(Sender: TObject);
begin

end;

////// prodedimiento para validar la clave del usuario
procedure TFMenu.WebButton2Click(Sender: TObject);
begin
ConUsuarios.URI:='https://begins-builder-allied-strength.trycloudflare.com/Usuarios?Usuario='+
  Base64Encode(EditUsuario.Text)+'&Clave='+Base64Encode(EditClave.Text);
ConUsuarios.Active:=True;
SleepAsync(300, procedure
  begin

  BanderaIn:='n';
  Mllave:=EditUsuario.Text+EditClave.Text;
  if Mllave=Base64decode(Tusuarios.FieldByName('llave').AsString) then BAnderaIn:='s';

  //if TUsuarios.Locate('llave',Base64Encode(Mllave),[]) then  BAnderaIn:='s';

  //if (WEditUsuario.Text='Eugenio') And (WEditClave.Text='Eugenio123') Then
  //    BanderaIn:='s';
  if BanderaIn='n' then
    Begin
    ShowMessage('Error Clave incorrecta, intente de nuevo !!!!');
    EditUsuario.SetFocus;
    exit;
    End;
  WPanel1.Visible:=False;
  WPanel2.Visible:=True;
  WebImageControl1.Visible:=True;
  WebLabel2.Visible:=True;
  WebLabel24.Visible:=True;

  conSolicitudHdr.URI:='https://begins-builder-allied-strength.trycloudflare.com/SolicitudHDR?Usuario='+
    Base64Encode('ADMINALL')+'&Clave='+Base64Encode('ADdd11NALL9087726');
  conSolicitudDet.URI:='https://begins-builder-allied-strength.trycloudflare.com/SolicitudDET?Usuario='+
    Base64Encode('ADMINALL')+'&Clave='+Base64Encode('ADdd11NALL9087726');
  ConSolicitudHdr.Active:=True;
  ConSolicitudDet.Active:=True;
  end);
End;

/// boton se salir de la froma de agregar encabezados
procedure TFMenu.WebButton4Click(Sender: TObject);
begin
end;

///// boton de agregar forma de encabezados solicitudHdr
procedure TFMenu.WebButton7Click(Sender: TObject);
begin
end;

/// boton de editar
//// froma de encabezado SolicitudHdr
procedure TFMenu.WebButton9Click(Sender: TObject);
begin
end;

///// funcion para cuando sale de la fecha
/// iguala la fecha al campo de la forma fechapedido
procedure TFMenu.WebDateTimePicker1Exit(Sender: TObject);
begin
DecodeDate(WebDateTimePicker1.Date,Ano,Mes,Dia);
EditFechaPedido.Text:=FormatFloat('00',mes)+'/'+
  FormatFloat('00',dia)+'/'+IntToStr(Ano);
//EditFechaPedido.Text:=FormatDateTime('mm/dd/aaaa',WebDateTimePicker1.Date);
WebDateTimePicker1.Visible:=False;
EditFechaPedido.Visible:=True;
end;

procedure TFMenu.WebDateTimePicker2Exit(Sender: TObject);
begin
DecodeDate(WebDateTimePicker2.Date,Ano,Mes,Dia);
EditFechaFinalizada.Text:=FormatFloat('00',mes)+
  '/'+FormatFloat('00',dia)+'/'+IntToStr(Ano);
//EditFechaPedido.Text:=FormatDateTime('mm/dd/aaaa',WebDateTimePicker1.Date);
WebDateTimePicker2.Visible:=False;
EditFechaFinalizada.Visible:=True;

end;

procedure TFMenu.WebFormShow(Sender: TObject);
begin
DesActivaCapturaHdr;
DesActivaCapturaDet;
WPanel2.Top:=WPanel1.Top;
WPanel2.Left:=WPanel1.Left;
WebPageControl1.Top:=WPanel1.Top;
WebPageControl1.Left:=WPanel1.Left;
//// forma de los empleados
WebPanel2.Align:=Altop;
WebPanel3.Align:=AlClient;
WebDBGrid2.Align:=AlClient;

WPanel2.Visible:=False;
WebPageControl1.visible:=False;
MBandera:='';
WebDateTimePicker1.Visible:=False;
WebDateTimePicker2.Visible:=False;
WebPageControl1.TabIndex:=0;
WebImageControl1.Visible:=False;
WebLabel2.Visible:=False;
WebLabel2.Visible:=False;
WebLabel24.Visible:=False;
end;

procedure TFMenu.WebHttpRequest1Response(Sender: TObject; AResponse: string);
begin
if AResponse = 'Eliminado correctamente!!' then
  ShowMessage('Registro eliminado');

end;

procedure TFMenu.WebSpeedButton10Click(Sender: TObject);
begin
DesActivaCapturaHdr;

end;

procedure TFMenu.WebSpeedButton11Click(Sender: TObject);
begin
TSolicitudDet.Filtered:=False;
TSolicitudDet.Insert;
ActivaCapturaDet;
MBandera:='A';
EditFolioD.Text:=EditFolio.Text;

end;

procedure TFMenu.WebSpeedButton12Click(Sender: TObject);
begin
TSolicitudDet.Edit;
ActivaCapturaDet;
MBandera:='M';

end;

////// procedimiento para borar solicitudDET
/// encabezado del documento
procedure TFMenu.WebSpeedButton13Click(Sender: TObject);
Var   Data: TJSONObject;
begin
 if window.confirm('¿Estás seguro de que deseas borrar este Empleado?') then
  begin
    // Código para borrar el empleado
    //ShowMessage('Registro borrado.');


    Data := TJSONObject.Create;
    try
      Data.AddPair('Folio', EditFolio.Text);

     Data.AddPair('Numero', EditNumero.Text);

      WebHttpRequest1.URL := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudDET';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpDELETE;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;


  ConSolicitudDET.Active:=False;
  TSolicitudDET.Active:=False;
  WebTimer2.Enabled:=True;
  end;

end;

procedure TFMenu.WebSpeedButton14Click(Sender: TObject);
begin
DesActivaCapturaDet;
DesActivaCapturaHdr;
WebPageControl1.TabIndex:=0;

//WebPageControl1.Visible:=False;
//WPanel2.Visible:=True;

end;

procedure TFMenu.WebSpeedButton15Click(Sender: TObject);
begin
If MBandera='A' then AgregaDet;
if MBandera='M' then ModificaDet;

DesActivaCapturaDet;
ConSolicitudDet.Active:=False;
TSolicitudDet.Active:=False;
WebTimer2.Enabled:=True;
FiltraDet;

end;

procedure TFMenu.WebSpeedButton16Click(Sender: TObject);
begin
TSolicitudDet.Cancel;
DesActivaCapturaDet;
FiltraDet;

end;

procedure TFMenu.WebSpeedButton17Click(Sender: TObject);
begin
ConEmpleados.URI:='https://begins-builder-allied-strength.trycloudflare.com/Empleados?Numero='+ ///http://137.131.43.175:9000
  EditNumero.Text;
ConEmpleados.Active:=True;

If not TEmpleados.Locate('Numero',EditNumero.Text,[]) Then
  BEgin
  ShowMessage('Error: empleado no encontrado');
  End;
EditNumero.Text:=TEmpleados.FieldByName('Numero').AsString;
EditEmpPaterno.Text:=TEmpleados.FieldByName('Paterno').AsString;
EditEmpMaterno.Text:=TEmpleados.FieldByName('Materno').AsString;
EditEmpNombre.Text:=TEmpleados.FieldByName('Nombre').AsString;
EditPuesto.Text:=TEmpleados.FieldByName('Puesto').AsString;
if TPuestos.locate('Clave', TEmpleados.FieldByName('Puesto').AsString,[]) then
  Begin
  TSolicitudDet.FieldByName('PuestoNombre').AsString:=TPuestos.FieldByName('Puesto').AsString;
  End;
ConEmpleados.Active:=False;
end;

procedure TFMenu.WebSpeedButton1Click(Sender: TObject);
begin
WPanel2.Visible:=False;
WebPageControl1.Visible:=True;
DesActivaCapturaHdr;

end;

procedure TFMenu.WebSpeedButton2Click(Sender: TObject);
Var   Data: TJSONObject;
Folio, URL: string;
begin
Folio:=EditFolioi.Text;

URL := 'https://begins-builder-allied-strength.trycloudflare.com/PDFReporteDwk?FOLIO=' + Folio;
  asm
  window.open(URL, '_blank');
  end;


end;

procedure TFMenu.WebSpeedButton3Click(Sender: TObject);
begin
TSolicitudhdr.Insert;
ActivaCapturaHdr;
MBandera:='A';

end;

procedure TFMenu.WebSpeedButton4Click(Sender: TObject);
begin
TSolicitudHdr.Edit;
MBandera:='M';
ActivaCapturaHdr;
EditFolioi.Text:=TSolicitudHdr.FieldByName('Folio').AsString;
end;

////// procedimiento para borar solicitudHdr
/// encabezado del documento
procedure TFMenu.WebSpeedButton5Click(Sender: TObject);
Var   Data: TJSONObject;
begin
 if window.confirm('¿Estás seguro de que deseas borrar este registro?') then
  begin
    // Código para borrar el registro
    //ShowMessage('Registro borrado.');


    Data := TJSONObject.Create;
    try
      Data.AddPair('Folio', EditFolio.Text);

      WebHttpRequest1.URL := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudHDR';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpDELETE;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;


  ConSolicitudHdr.Active:=False;
  TSolicitudHdr.Active:=False;
  WebTimer1.Enabled:=True;
  end

end;

procedure TFMenu.WebTimer1Timer(Sender: TObject);
begin
ConSolicitudHdr.Active:=True;
TSolicitudHdr.Active:=True;
WebTimer1.Enabled:=False;

end;

procedure TFMenu.WebTimer2Timer(Sender: TObject);
begin
ConSolicitudDet.Active:=True;
TSolicitudDet.Active:=True;
WebTimer2.Enabled:=False;

end;

procedure TFMenu.ActivaCapturaHdr;
begin
WebPanel1.Visible:=False;
WPanel3.Visible:=True;
WebDBGrid1.Visible:=False;
WebPanel1.Align:=AlTop;
WebDBGrid1.Align:=AlClient;
WPanel3.Align:=AlNone;

end;

procedure TFMenu.DesActivaCapturaHdr;
begin
WebPanel1.Visible:=True;
WPanel3.Visible:=False;
WebDBGrid1.Visible:=True;
WebPanel1.Align:=AlTop;
WebDBGrid1.Align:=AlClient;
WPanel3.Align:=AlClient;
end;


procedure TFMenu.EditFechaFinalizadaEnter(Sender: TObject);
begin
WebDateTimePicker2.Top:=EditFechaFinalizada.Top;
WebDateTimePicker2.Left:=EditFechaFinalizada.Left;
EditFechaFinalizada.Visible:=False;
WebDateTimePicker2.Visible:=True;
WebDateTimePicker2.SetFocus;

end;

procedure TFMenu.EditFechaPedidoEnter(Sender: TObject);
begin
WebDateTimePicker1.Top:=EditFechaPedido.Top;
WebDateTimePicker1.Left:=EditFechaPedido.Left;
EditFechaPedido.Visible:=False;
WebDateTimePicker1.Visible:=True;
WebDateTimePicker1.SetFocus;
end;

procedure TFMenu.EmpleadosShow(Sender: TObject);
begin
FiltraDet;
end;

procedure TFMenu.FiltraDet;
begin
TSolicitudDet.Filtered:=False;
TSolicitudDet.Filter:='Folio='+chr(39)+TSolicitudHdr.FieldByName('Folio').AsString+chr(39);
TSolicitudDet.Filtered:=True;
EditFolioD.Text:=EditFolio.Text;
End;

procedure TFMenu.ActivaCapturaDet;
begin
WebPanel2.Visible:=False;
WebPanel3.Visible:=True;
WebDBGrid2.Visible:=False;
WebPanel2.Align:=AlTop;
WebDBGrid2.Align:=AlBottom;
WebPanel3.Align:=AlClient;

end;

procedure TFMenu.DesActivaCapturaDet;
begin
WebPanel2.Visible:=True;
WebPanel3.Visible:=False;
WebDBGrid2.Visible:=True;
WebPanel2.Align:=AlTop;
WebDBGrid2.Align:=Alclient;
WebPanel3.Align:=AlClient;
end;

procedure TFMenu.WebSpeedButton6Click(Sender: TObject);
begin
if not TSolicitudHdr.Locate('Folio',EditBuscar.Text,[]) Then
  Begin
  ShowMessage('Folio no encontrado!!!');
  End;

end;

procedure TFMenu.WebSpeedButton7Click(Sender: TObject);
begin
WebPageControl1.Visible:=False;
WPanel2.Visible:=True;
EditFolioi.Text:=TSolicitudHdr.FieldByName('Folio').AsString;
end;

procedure TFMenu.WebSpeedButton8Click(Sender: TObject);
begin
Close;

end;

procedure TFMenu.WebSpeedButton9Click(Sender: TObject);
begin
If MBandera='A' then AgregaHdr;
if MBandera='M' then ModificaHdr;
EditBuscar.Text:=EditFolio.Text;
DesActivaCapturaHdr;
ConSolicitudHdr.Active:=False;
TSolicitudHdr.Active:=False;
WebTimer1.Enabled:=True;

//if EditFolioi.Text>'' then
//  Begin
//  TSolicitudHdr.Locate('Folio',EditFolioi.Text,[]);
//  End;

end;

procedure TFMenu.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WPanel1 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebButton2 := TButton.Create(Self);
  EditUsuario := TEdit.Create(Self);
  EditClave := TEdit.Create(Self);
  WPanel2 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  EditFolioi := TEdit.Create(Self);
  WebSpeedButton18 := TSpeedButton.Create(Self);
  WebSpeedButton19 := TSpeedButton.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WPanel3 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  EditFolio := TDBEdit.Create(Self);
  EditFechaPedido := TDBEdit.Create(Self);
  EditNombre := TDBEdit.Create(Self);
  EditNombre2 := TDBEdit.Create(Self);
  EditDepto := TDBEdit.Create(Self);
  EditDepto2 := TDBEdit.Create(Self);
  EditDocumentoNombre := TDBEdit.Create(Self);
  EditRevision := TDBEdit.Create(Self);
  EditNoDocumento := TDBEdit.Create(Self);
  EditAlcance := TDBEdit.Create(Self);
  EditFechaFinalizada := TDBEdit.Create(Self);
  EditOnClass := TDBEdit.Create(Self);
  EditOnDem := TDBEdit.Create(Self);
  EditOnJob := TDBEdit.Create(Self);
  EditOnVideo := TDBEdit.Create(Self);
  EditOnSemin := TDBEdit.Create(Self);
  EditOnSelf := TDBEdit.Create(Self);
  EditOnOther := TDBEdit.Create(Self);
  EditDuracion := TDBEdit.Create(Self);
  EditDuracionTotal := TDBEdit.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  WebDateTimePicker2 := TDateTimePicker.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  EditBuscar := TEdit.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  Empleados := TTabSheet.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  WebSpeedButton13 := TSpeedButton.Create(Self);
  WebSpeedButton14 := TSpeedButton.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  EditNumero := TDBEdit.Create(Self);
  EditEmpPaterno := TDBEdit.Create(Self);
  EditEmpMaterno := TDBEdit.Create(Self);
  EditEmpNombre := TDBEdit.Create(Self);
  EditPuesto := TDBEdit.Create(Self);
  EditPuestoNombre := TDBEdit.Create(Self);
  EditFolioD := TDBEdit.Create(Self);
  WebSpeedButton15 := TSpeedButton.Create(Self);
  WebSpeedButton16 := TSpeedButton.Create(Self);
  WebSpeedButton17 := TSpeedButton.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  ConSolicitudHdr := TClientConnection.Create(Self);
  TSolicitudHdr := TClientDataSet.Create(Self);
  DsSolicitudHdr := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  ConSolicitudDET := TClientConnection.Create(Self);
  TSolicitudDet := TClientDataSet.Create(Self);
  DsSolicitudDet := TDataSource.Create(Self);
  WebTimer2 := TTimer.Create(Self);
  ConEmpleados := TClientConnection.Create(Self);
  TEmpleados := TClientDataSet.Create(Self);
  DSEmpleados := TDataSource.Create(Self);
  ConUsuarios := TClientConnection.Create(Self);
  TUsuarios := TClientDataSet.Create(Self);
  ConPuestos := TClientConnection.Create(Self);
  TPuestos := TClientDataSet.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WPanel1.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  EditUsuario.BeforeLoadDFMValues;
  EditClave.BeforeLoadDFMValues;
  WPanel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  EditFolioi.BeforeLoadDFMValues;
  WebSpeedButton18.BeforeLoadDFMValues;
  WebSpeedButton19.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WPanel3.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  EditFolio.BeforeLoadDFMValues;
  EditFechaPedido.BeforeLoadDFMValues;
  EditNombre.BeforeLoadDFMValues;
  EditNombre2.BeforeLoadDFMValues;
  EditDepto.BeforeLoadDFMValues;
  EditDepto2.BeforeLoadDFMValues;
  EditDocumentoNombre.BeforeLoadDFMValues;
  EditRevision.BeforeLoadDFMValues;
  EditNoDocumento.BeforeLoadDFMValues;
  EditAlcance.BeforeLoadDFMValues;
  EditFechaFinalizada.BeforeLoadDFMValues;
  EditOnClass.BeforeLoadDFMValues;
  EditOnDem.BeforeLoadDFMValues;
  EditOnJob.BeforeLoadDFMValues;
  EditOnVideo.BeforeLoadDFMValues;
  EditOnSemin.BeforeLoadDFMValues;
  EditOnSelf.BeforeLoadDFMValues;
  EditOnOther.BeforeLoadDFMValues;
  EditDuracion.BeforeLoadDFMValues;
  EditDuracionTotal.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  WebDateTimePicker2.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  EditBuscar.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  Empleados.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  WebSpeedButton13.BeforeLoadDFMValues;
  WebSpeedButton14.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  EditNumero.BeforeLoadDFMValues;
  EditEmpPaterno.BeforeLoadDFMValues;
  EditEmpMaterno.BeforeLoadDFMValues;
  EditEmpNombre.BeforeLoadDFMValues;
  EditPuesto.BeforeLoadDFMValues;
  EditPuestoNombre.BeforeLoadDFMValues;
  EditFolioD.BeforeLoadDFMValues;
  WebSpeedButton15.BeforeLoadDFMValues;
  WebSpeedButton16.BeforeLoadDFMValues;
  WebSpeedButton17.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  ConSolicitudHdr.BeforeLoadDFMValues;
  TSolicitudHdr.BeforeLoadDFMValues;
  DsSolicitudHdr.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  ConSolicitudDET.BeforeLoadDFMValues;
  TSolicitudDet.BeforeLoadDFMValues;
  DsSolicitudDet.BeforeLoadDFMValues;
  WebTimer2.BeforeLoadDFMValues;
  ConEmpleados.BeforeLoadDFMValues;
  TEmpleados.BeforeLoadDFMValues;
  DSEmpleados.BeforeLoadDFMValues;
  ConUsuarios.BeforeLoadDFMValues;
  TUsuarios.BeforeLoadDFMValues;
  ConPuestos.BeforeLoadDFMValues;
  TPuestos.BeforeLoadDFMValues;
  try
    Name := 'FMenu';
    Width := 1129;
    Height := 788;
    Caption := 'TSolicitudHdr';
    Color := 13041663;
    Font.Charset := ANSI_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -12;
    Font.Name := 'Book Antiqua';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 40;
    WebImageControl1.Top := 21;
    WebImageControl1.Width := 318;
    WebImageControl1.Height := 43;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.AutoSize := True;
    WebImageControl1.ChildOrder := 2;
    WebImageControl1.Picture.LoadFromFile('Menu.WebImageControl1.Picture.jpg');
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 45;
    WebLabel2.Top := 70;
    WebLabel2.Width := 185;
    WebLabel2.Height := 20;
    WebLabel2.Caption := 'Solicitud de entrenamientos';
    WebLabel2.Color := 15138815;
    WebLabel2.Font.Charset := ANSI_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -15;
    WebLabel2.Font.Name := 'Book Antiqua';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel24.SetParentComponent(Self);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 42;
    WebLabel24.Top := 87;
    WebLabel24.Width := 75;
    WebLabel24.Height := 20;
    WebLabel24.Caption := 'Version 1.8';
    WebLabel24.Color := 15138815;
    WebLabel24.Font.Charset := ANSI_CHARSET;
    WebLabel24.Font.Color := clWindowText;
    WebLabel24.Font.Height := -15;
    WebLabel24.Font.Name := 'Book Antiqua';
    WebLabel24.Font.Style := [];
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.ParentFont := False;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WPanel1.SetParentComponent(Self);
    WPanel1.Name := 'WPanel1';
    WPanel1.Left := 65;
    WPanel1.Top := 111;
    WPanel1.Width := 450;
    WPanel1.Height := 157;
    WPanel1.HeightPercent := 100.000000000000000000;
    WPanel1.WidthPercent := 100.000000000000000000;
    WPanel1.BorderColor := clSilver;
    WPanel1.BorderStyle := bsNone;
    WPanel1.ChildOrder := 3;
    WebLabel3.SetParentComponent(WPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 30;
    WebLabel3.Top := 35;
    WebLabel3.Width := 46;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Usuario:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 35;
    WebLabel4.Top := 58;
    WebLabel4.Width := 35;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Clave:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebImageControl2.SetParentComponent(WPanel1);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 171;
    WebImageControl2.Top := -50;
    WebImageControl2.Width := 284;
    WebImageControl2.Height := 227;
    WebImageControl2.HeightPercent := 100.000000000000000000;
    WebImageControl2.WidthPercent := 100.000000000000000000;
    WebImageControl2.ChildOrder := 6;
    WebImageControl2.Picture.LoadFromFile('Menu.WPanel1.WebImageControl2.Picture.png');
    WebButton2.SetParentComponent(WPanel1);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 114;
    WebButton2.Top := 81;
    WebButton2.Width := 51;
    WebButton2.Height := 28;
    WebButton2.Caption := 'OK';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    EditUsuario.SetParentComponent(WPanel1);
    EditUsuario.Name := 'EditUsuario';
    EditUsuario.Left := 79;
    EditUsuario.Top := 29;
    EditUsuario.Width := 114;
    EditUsuario.Height := 22;
    EditUsuario.ChildOrder := 3;
    EditUsuario.HeightPercent := 100.000000000000000000;
    EditUsuario.WidthPercent := 100.000000000000000000;
    EditClave.SetParentComponent(WPanel1);
    EditClave.Name := 'EditClave';
    EditClave.Left := 79;
    EditClave.Top := 54;
    EditClave.Width := 114;
    EditClave.Height := 22;
    EditClave.ChildOrder := 3;
    EditClave.HeightPercent := 100.000000000000000000;
    EditClave.PasswordChar := '*';
    EditClave.Text := 'Eugenio123';
    EditClave.WidthPercent := 100.000000000000000000;
    WPanel2.SetParentComponent(Self);
    WPanel2.Name := 'WPanel2';
    WPanel2.Left := 27;
    WPanel2.Top := 226;
    WPanel2.Width := 1094;
    WPanel2.Height := 633;
    WPanel2.HeightPercent := 100.000000000000000000;
    WPanel2.WidthPercent := 100.000000000000000000;
    WPanel2.BorderColor := clSilver;
    WPanel2.BorderStyle := bsNone;
    WPanel2.ChildOrder := 5;
    WPanel2.Color := 13041663;
    WebLabel1.SetParentComponent(WPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 75;
    WebLabel1.Top := 148;
    WebLabel1.Width := 67;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'SOLICITAR ';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -13;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 289;
    WebLabel5.Top := 152;
    WebLabel5.Width := 69;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'IMPRESION ';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WPanel2);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 684;
    WebLabel20.Top := 153;
    WebLabel20.Width := 81;
    WebLabel20.Height := 16;
    WebLabel20.Caption := 'PARAMETROS';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebLabel35.SetParentComponent(WPanel2);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 1027;
    WebLabel35.Top := 94;
    WebLabel35.Width := 34;
    WebLabel35.Height := 16;
    WebLabel35.Caption := 'SALIR';
    WebLabel35.HeightPercent := 100.000000000000000000;
    WebLabel35.WidthPercent := 100.000000000000000000;
    WebLabel36.SetParentComponent(WPanel2);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 267;
    WebLabel36.Top := 188;
    WebLabel36.Width := 42;
    WebLabel36.Height := 16;
    WebLabel36.Caption := 'FOLIO: ';
    WebLabel36.HeightPercent := 100.000000000000000000;
    WebLabel36.WidthPercent := 100.000000000000000000;
    WebLabel37.SetParentComponent(WPanel2);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 498;
    WebLabel37.Top := 156;
    WebLabel37.Width := 60;
    WebLabel37.Height := 16;
    WebLabel37.Caption := 'USUARIOS';
    WebLabel37.HeightPercent := 100.000000000000000000;
    WebLabel37.WidthPercent := 100.000000000000000000;
    WebLabel19.SetParentComponent(WPanel2);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 57;
    WebLabel19.Top := 163;
    WebLabel19.Width := 100;
    WebLabel19.Height := 16;
    WebLabel19.Caption := 'ENTRENAMIENTO';
    WebLabel19.Font.Charset := DEFAULT_CHARSET;
    WebLabel19.Font.Color := clWindowText;
    WebLabel19.Font.Height := -13;
    WebLabel19.Font.Name := 'Tahoma';
    WebLabel19.Font.Style := [];
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.ParentFont := False;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel38.SetParentComponent(WPanel2);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 279;
    WebLabel38.Top := 168;
    WebLabel38.Width := 96;
    WebLabel38.Height := 16;
    WebLabel38.Caption := 'DE SOLICITUDES';
    WebLabel38.HeightPercent := 100.000000000000000000;
    WebLabel38.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(WPanel2);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 32;
    WebSpeedButton1.Top := 15;
    WebSpeedButton1.Width := 183;
    WebSpeedButton1.Height := 132;
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('Menu.WPanel2.WebSpeedButton1.Glyph.bmp');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WPanel2);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 240;
    WebSpeedButton2.Top := 15;
    WebSpeedButton2.Width := 183;
    WebSpeedButton2.Height := 132;
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('Menu.WPanel2.WebSpeedButton2.Glyph.bmp');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton8.SetParentComponent(WPanel2);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 1014;
    WebSpeedButton8.Top := 13;
    WebSpeedButton8.Width := 65;
    WebSpeedButton8.Height := 74;
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.Glyph.LoadFromFile('Menu.WPanel2.WebSpeedButton8.Glyph.bmp');
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    EditFolioi.SetParentComponent(WPanel2);
    EditFolioi.Name := 'EditFolioi';
    EditFolioi.Left := 312;
    EditFolioi.Top := 186;
    EditFolioi.Width := 82;
    EditFolioi.Height := 24;
    EditFolioi.ChildOrder := 4;
    EditFolioi.Font.Charset := ANSI_CHARSET;
    EditFolioi.Font.Color := clWindowText;
    EditFolioi.Font.Height := -12;
    EditFolioi.Font.Name := 'Book Antiqua';
    EditFolioi.Font.Style := [];
    EditFolioi.HeightPercent := 100.000000000000000000;
    EditFolioi.ParentFont := False;
    EditFolioi.WidthPercent := 100.000000000000000000;
    WebSpeedButton18.SetParentComponent(WPanel2);
    WebSpeedButton18.Name := 'WebSpeedButton18';
    WebSpeedButton18.Left := 441;
    WebSpeedButton18.Top := 15;
    WebSpeedButton18.Width := 183;
    WebSpeedButton18.Height := 132;
    WebSpeedButton18.Color := clNone;
    WebSpeedButton18.Glyph.LoadFromFile('Menu.WPanel2.WebSpeedButton18.Glyph.bmp');
    WebSpeedButton18.HeightPercent := 100.000000000000000000;
    WebSpeedButton18.WidthPercent := 100.000000000000000000;
    WebSpeedButton19.SetParentComponent(WPanel2);
    WebSpeedButton19.Name := 'WebSpeedButton19';
    WebSpeedButton19.Left := 635;
    WebSpeedButton19.Top := 13;
    WebSpeedButton19.Width := 183;
    WebSpeedButton19.Height := 134;
    WebSpeedButton19.Color := clNone;
    WebSpeedButton19.Glyph.LoadFromFile('Menu.WPanel2.WebSpeedButton19.Glyph.bmp');
    WebSpeedButton19.HeightPercent := 100.000000000000000000;
    WebSpeedButton19.WidthPercent := 100.000000000000000000;
    WebPageControl1.SetParentComponent(Self);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 118;
    WebPageControl1.Top := 404;
    WebPageControl1.Width := 988;
    WebPageControl1.Height := 718;
    WebPageControl1.HeightPercent := 100.000000000000000000;
    WebPageControl1.WidthPercent := 100.000000000000000000;
    WebPageControl1.ChildOrder := 5;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.TabOrder := 2;
    WebPageControl1Sheet1.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 988;
    WebPageControl1Sheet1.Height := 698;
    WebPageControl1Sheet1.HeightPercent := 100.000000000000000000;
    WebPageControl1Sheet1.WidthPercent := 100.000000000000000000;
    WebPageControl1Sheet1.Caption := 'DATOS SOLICITUD       ';
    WebPageControl1Sheet1.ChildOrder := 3;
    WPanel3.SetParentComponent(WebPageControl1Sheet1);
    WPanel3.Name := 'WPanel3';
    WPanel3.Left := 3;
    WPanel3.Top := 96;
    WPanel3.Width := 942;
    WPanel3.Height := 420;
    WPanel3.HeightPercent := 100.000000000000000000;
    WPanel3.WidthPercent := 100.000000000000000000;
    WPanel3.BorderColor := clSilver;
    WPanel3.BorderStyle := bsSingle;
    WPanel3.ChildOrder := 4;
    WPanel3.Color := 15532012;
    WebLabel6.SetParentComponent(WPanel3);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 19;
    WebLabel6.Top := 27;
    WebLabel6.Width := 94;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Numero de folio:';
    WebLabel6.Font.Charset := ANSI_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -12;
    WebLabel6.Font.Name := 'Book Antiqua';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WPanel3);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 77;
    WebLabel7.Top := 50;
    WebLabel7.Width := 34;
    WebLabel7.Height := 16;
    WebLabel7.Caption := 'Fecha:';
    WebLabel7.Font.Charset := ANSI_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -12;
    WebLabel7.Font.Name := 'Book Antiqua';
    WebLabel7.Font.Style := [];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WPanel3);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 35;
    WebLabel8.Top := 78;
    WebLabel8.Width := 128;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'Nombre del solicitante:';
    WebLabel8.Font.Charset := ANSI_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -12;
    WebLabel8.Font.Name := 'Book Antiqua';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WPanel3);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 15;
    WebLabel9.Top := 102;
    WebLabel9.Width := 181;
    WebLabel9.Height := 16;
    WebLabel9.Caption := 'Nombre a quien se lo solicitaron:';
    WebLabel9.Font.Charset := ANSI_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -12;
    WebLabel9.Font.Name := 'Book Antiqua';
    WebLabel9.Font.Style := [];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WPanel3);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 47;
    WebLabel11.Top := 197;
    WebLabel11.Width := 146;
    WebLabel11.Height := 16;
    WebLabel11.Caption := 'Departamento que solicita:';
    WebLabel11.Font.Charset := ANSI_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -12;
    WebLabel11.Font.Name := 'Book Antiqua';
    WebLabel11.Font.Style := [];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WPanel3);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 40;
    WebLabel12.Top := 222;
    WebLabel12.Width := 213;
    WebLabel12.Height := 16;
    WebLabel12.Caption := 'Departamento a quien se lo solicitaron:';
    WebLabel12.Font.Charset := ANSI_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -12;
    WebLabel12.Font.Name := 'Book Antiqua';
    WebLabel12.Font.Style := [];
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.ParentFont := False;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WPanel3);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 67;
    WebLabel14.Top := 147;
    WebLabel14.Width := 133;
    WebLabel14.Height := 16;
    WebLabel14.Caption := 'Nombre del documento:';
    WebLabel14.Font.Charset := ANSI_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -12;
    WebLabel14.Font.Name := 'Book Antiqua';
    WebLabel14.Font.Style := [];
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WPanel3);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 147;
    WebLabel15.Top := 172;
    WebLabel15.Width := 51;
    WebLabel15.Height := 16;
    WebLabel15.Caption := 'Revision:';
    WebLabel15.Font.Charset := ANSI_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -12;
    WebLabel15.Font.Name := 'Book Antiqua';
    WebLabel15.Font.Style := [];
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.ParentFont := False;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WPanel3);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 80;
    WebLabel16.Top := 285;
    WebLabel16.Width := 129;
    WebLabel16.Height := 16;
    WebLabel16.Caption := 'Area del entrenamiento';
    WebLabel16.Font.Charset := ANSI_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -12;
    WebLabel16.Font.Name := 'Book Antiqua';
    WebLabel16.Font.Style := [];
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WPanel3);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 419;
    WebLabel17.Top := 305;
    WebLabel17.Width := 53;
    WebLabel17.Height := 16;
    WebLabel17.Caption := 'Duracion:';
    WebLabel17.Font.Charset := ANSI_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -12;
    WebLabel17.Font.Name := 'Book Antiqua';
    WebLabel17.Font.Style := [];
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WPanel3);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 403;
    WebLabel18.Top := 329;
    WebLabel18.Width := 73;
    WebLabel18.Height := 16;
    WebLabel18.Caption := 'Tiempo total:';
    WebLabel18.Font.Charset := ANSI_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -12;
    WebLabel18.Font.Name := 'Book Antiqua';
    WebLabel18.Font.Style := [];
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.ParentFont := False;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebLabel25.SetParentComponent(WPanel3);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 64;
    WebLabel25.Top := 309;
    WebLabel25.Width := 65;
    WebLabel25.Height := 16;
    WebLabel25.Caption := 'Class room:';
    WebLabel25.Font.Charset := ANSI_CHARSET;
    WebLabel25.Font.Color := clWindowText;
    WebLabel25.Font.Height := -12;
    WebLabel25.Font.Name := 'Book Antiqua';
    WebLabel25.Font.Style := [];
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.ParentFont := False;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebLabel26.SetParentComponent(WPanel3);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 52;
    WebLabel26.Top := 333;
    WebLabel26.Width := 78;
    WebLabel26.Height := 16;
    WebLabel26.Caption := 'Demostration:';
    WebLabel26.Font.Charset := ANSI_CHARSET;
    WebLabel26.Font.Color := clWindowText;
    WebLabel26.Font.Height := -12;
    WebLabel26.Font.Name := 'Book Antiqua';
    WebLabel26.Font.Style := [];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel27.SetParentComponent(WPanel3);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 75;
    WebLabel27.Top := 357;
    WebLabel27.Width := 59;
    WebLabel27.Height := 16;
    WebLabel27.Caption := 'On the job:';
    WebLabel27.Font.Charset := ANSI_CHARSET;
    WebLabel27.Font.Color := clWindowText;
    WebLabel27.Font.Height := -12;
    WebLabel27.Font.Name := 'Book Antiqua';
    WebLabel27.Font.Style := [];
    WebLabel27.HeightPercent := 100.000000000000000000;
    WebLabel27.ParentFont := False;
    WebLabel27.WidthPercent := 100.000000000000000000;
    WebLabel28.SetParentComponent(WPanel3);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 91;
    WebLabel28.Top := 381;
    WebLabel28.Width := 36;
    WebLabel28.Height := 16;
    WebLabel28.Caption := 'Video:';
    WebLabel28.Font.Charset := ANSI_CHARSET;
    WebLabel28.Font.Color := clWindowText;
    WebLabel28.Font.Height := -12;
    WebLabel28.Font.Name := 'Book Antiqua';
    WebLabel28.Font.Style := [];
    WebLabel28.HeightPercent := 100.000000000000000000;
    WebLabel28.ParentFont := False;
    WebLabel28.WidthPercent := 100.000000000000000000;
    WebLabel29.SetParentComponent(WPanel3);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 195;
    WebLabel29.Top := 309;
    WebLabel29.Width := 104;
    WebLabel29.Height := 16;
    WebLabel29.Caption := 'Seminars/Courses:';
    WebLabel29.Font.Charset := ANSI_CHARSET;
    WebLabel29.Font.Color := clWindowText;
    WebLabel29.Font.Height := -12;
    WebLabel29.Font.Name := 'Book Antiqua';
    WebLabel29.Font.Style := [];
    WebLabel29.HeightPercent := 100.000000000000000000;
    WebLabel29.ParentFont := False;
    WebLabel29.WidthPercent := 100.000000000000000000;
    WebLabel30.SetParentComponent(WPanel3);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 177;
    WebLabel30.Top := 334;
    WebLabel30.Width := 123;
    WebLabel30.Height := 16;
    WebLabel30.Caption := 'Self study of company:';
    WebLabel30.Font.Charset := ANSI_CHARSET;
    WebLabel30.Font.Color := clWindowText;
    WebLabel30.Font.Height := -12;
    WebLabel30.Font.Name := 'Book Antiqua';
    WebLabel30.Font.Style := [];
    WebLabel30.HeightPercent := 100.000000000000000000;
    WebLabel30.ParentFont := False;
    WebLabel30.WidthPercent := 100.000000000000000000;
    WebLabel31.SetParentComponent(WPanel3);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 264;
    WebLabel31.Top := 357;
    WebLabel31.Width := 34;
    WebLabel31.Height := 16;
    WebLabel31.Caption := 'Other:';
    WebLabel31.Font.Charset := ANSI_CHARSET;
    WebLabel31.Font.Color := clWindowText;
    WebLabel31.Font.Height := -12;
    WebLabel31.Font.Name := 'Book Antiqua';
    WebLabel31.Font.Style := [];
    WebLabel31.HeightPercent := 100.000000000000000000;
    WebLabel31.ParentFont := False;
    WebLabel31.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WPanel3);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 69;
    WebLabel10.Top := 124;
    WebLabel10.Width := 129;
    WebLabel10.Height := 16;
    WebLabel10.Caption := 'Numero de documento:';
    WebLabel10.Font.Charset := ANSI_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -12;
    WebLabel10.Font.Name := 'Book Antiqua';
    WebLabel10.Font.Style := [];
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WPanel3);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 20;
    WebLabel13.Top := 247;
    WebLabel13.Width := 45;
    WebLabel13.Height := 16;
    WebLabel13.Caption := 'Alcance:';
    WebLabel13.Font.Charset := ANSI_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -12;
    WebLabel13.Font.Name := 'Book Antiqua';
    WebLabel13.Font.Style := [];
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel32.SetParentComponent(WPanel3);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 268;
    WebLabel32.Top := 50;
    WebLabel32.Width := 91;
    WebLabel32.Height := 16;
    WebLabel32.Caption := 'Fecha finalizada:';
    WebLabel32.Font.Charset := ANSI_CHARSET;
    WebLabel32.Font.Color := clWindowText;
    WebLabel32.Font.Height := -12;
    WebLabel32.Font.Name := 'Book Antiqua';
    WebLabel32.Font.Style := [];
    WebLabel32.HeightPercent := 100.000000000000000000;
    WebLabel32.ParentFont := False;
    WebLabel32.WidthPercent := 100.000000000000000000;
    EditFolio.SetParentComponent(WPanel3);
    EditFolio.Name := 'EditFolio';
    EditFolio.Left := 120;
    EditFolio.Top := 24;
    EditFolio.Width := 121;
    EditFolio.Height := 22;
    EditFolio.CharCase := wecUpperCase;
    EditFolio.ChildOrder := 1;
    EditFolio.Font.Charset := ANSI_CHARSET;
    EditFolio.Font.Color := clWindowText;
    EditFolio.Font.Height := -12;
    EditFolio.Font.Name := 'Book Antiqua';
    EditFolio.Font.Style := [];
    EditFolio.HeightPercent := 100.000000000000000000;
    EditFolio.ParentFont := False;
    EditFolio.WidthPercent := 100.000000000000000000;
    EditFolio.DataField := 'folio';
    EditFolio.DataSource := DsSolicitudHdr;
    EditFechaPedido.SetParentComponent(WPanel3);
    EditFechaPedido.Name := 'EditFechaPedido';
    EditFechaPedido.Left := 120;
    EditFechaPedido.Top := 48;
    EditFechaPedido.Width := 121;
    EditFechaPedido.Height := 22;
    EditFechaPedido.CharCase := wecUpperCase;
    EditFechaPedido.ChildOrder := 1;
    EditFechaPedido.Font.Charset := ANSI_CHARSET;
    EditFechaPedido.Font.Color := clWindowText;
    EditFechaPedido.Font.Height := -12;
    EditFechaPedido.Font.Name := 'Book Antiqua';
    EditFechaPedido.Font.Style := [];
    EditFechaPedido.HeightPercent := 100.000000000000000000;
    EditFechaPedido.ParentFont := False;
    EditFechaPedido.WidthPercent := 100.000000000000000000;
    SetEvent(EditFechaPedido, Self, 'OnEnter', 'EditFechaPedidoEnter');
    EditFechaPedido.DataField := 'FechaPedido';
    EditFechaPedido.DataSource := DsSolicitudHdr;
    EditNombre.SetParentComponent(WPanel3);
    EditNombre.Name := 'EditNombre';
    EditNombre.Left := 170;
    EditNombre.Top := 75;
    EditNombre.Width := 282;
    EditNombre.Height := 22;
    EditNombre.CharCase := wecUpperCase;
    EditNombre.ChildOrder := 1;
    EditNombre.Font.Charset := ANSI_CHARSET;
    EditNombre.Font.Color := clWindowText;
    EditNombre.Font.Height := -12;
    EditNombre.Font.Name := 'Book Antiqua';
    EditNombre.Font.Style := [];
    EditNombre.HeightPercent := 100.000000000000000000;
    EditNombre.ParentFont := False;
    EditNombre.WidthPercent := 100.000000000000000000;
    EditNombre.DataField := 'Nombre';
    EditNombre.DataSource := DsSolicitudHdr;
    EditNombre2.SetParentComponent(WPanel3);
    EditNombre2.Name := 'EditNombre2';
    EditNombre2.Left := 204;
    EditNombre2.Top := 100;
    EditNombre2.Width := 282;
    EditNombre2.Height := 22;
    EditNombre2.CharCase := wecUpperCase;
    EditNombre2.ChildOrder := 1;
    EditNombre2.Font.Charset := ANSI_CHARSET;
    EditNombre2.Font.Color := clWindowText;
    EditNombre2.Font.Height := -12;
    EditNombre2.Font.Name := 'Book Antiqua';
    EditNombre2.Font.Style := [];
    EditNombre2.HeightPercent := 100.000000000000000000;
    EditNombre2.ParentFont := False;
    EditNombre2.WidthPercent := 100.000000000000000000;
    EditNombre2.DataField := 'Nombre2';
    EditNombre2.DataSource := DsSolicitudHdr;
    EditDepto.SetParentComponent(WPanel3);
    EditDepto.Name := 'EditDepto';
    EditDepto.Left := 204;
    EditDepto.Top := 195;
    EditDepto.Width := 257;
    EditDepto.Height := 22;
    EditDepto.CharCase := wecUpperCase;
    EditDepto.ChildOrder := 1;
    EditDepto.Font.Charset := ANSI_CHARSET;
    EditDepto.Font.Color := clWindowText;
    EditDepto.Font.Height := -12;
    EditDepto.Font.Name := 'Book Antiqua';
    EditDepto.Font.Style := [];
    EditDepto.HeightPercent := 100.000000000000000000;
    EditDepto.ParentFont := False;
    EditDepto.WidthPercent := 100.000000000000000000;
    EditDepto.DataField := 'Depto';
    EditDepto.DataSource := DsSolicitudHdr;
    EditDepto2.SetParentComponent(WPanel3);
    EditDepto2.Name := 'EditDepto2';
    EditDepto2.Left := 261;
    EditDepto2.Top := 219;
    EditDepto2.Width := 272;
    EditDepto2.Height := 22;
    EditDepto2.CharCase := wecUpperCase;
    EditDepto2.ChildOrder := 1;
    EditDepto2.Font.Charset := ANSI_CHARSET;
    EditDepto2.Font.Color := clWindowText;
    EditDepto2.Font.Height := -12;
    EditDepto2.Font.Name := 'Book Antiqua';
    EditDepto2.Font.Style := [];
    EditDepto2.HeightPercent := 100.000000000000000000;
    EditDepto2.ParentFont := False;
    EditDepto2.WidthPercent := 100.000000000000000000;
    EditDepto2.DataField := 'Depto2';
    EditDepto2.DataSource := DsSolicitudHdr;
    EditDocumentoNombre.SetParentComponent(WPanel3);
    EditDocumentoNombre.Name := 'EditDocumentoNombre';
    EditDocumentoNombre.Left := 204;
    EditDocumentoNombre.Top := 146;
    EditDocumentoNombre.Width := 350;
    EditDocumentoNombre.Height := 22;
    EditDocumentoNombre.CharCase := wecUpperCase;
    EditDocumentoNombre.ChildOrder := 1;
    EditDocumentoNombre.Font.Charset := ANSI_CHARSET;
    EditDocumentoNombre.Font.Color := clWindowText;
    EditDocumentoNombre.Font.Height := -12;
    EditDocumentoNombre.Font.Name := 'Book Antiqua';
    EditDocumentoNombre.Font.Style := [];
    EditDocumentoNombre.HeightPercent := 100.000000000000000000;
    EditDocumentoNombre.ParentFont := False;
    EditDocumentoNombre.WidthPercent := 100.000000000000000000;
    EditDocumentoNombre.DataField := 'DocumentoNombre';
    EditDocumentoNombre.DataSource := DsSolicitudHdr;
    EditRevision.SetParentComponent(WPanel3);
    EditRevision.Name := 'EditRevision';
    EditRevision.Left := 204;
    EditRevision.Top := 171;
    EditRevision.Width := 67;
    EditRevision.Height := 22;
    EditRevision.CharCase := wecUpperCase;
    EditRevision.ChildOrder := 1;
    EditRevision.Font.Charset := ANSI_CHARSET;
    EditRevision.Font.Color := clWindowText;
    EditRevision.Font.Height := -12;
    EditRevision.Font.Name := 'Book Antiqua';
    EditRevision.Font.Style := [];
    EditRevision.HeightPercent := 100.000000000000000000;
    EditRevision.ParentFont := False;
    EditRevision.WidthPercent := 100.000000000000000000;
    EditRevision.DataField := 'Revision';
    EditRevision.DataSource := DsSolicitudHdr;
    EditNoDocumento.SetParentComponent(WPanel3);
    EditNoDocumento.Name := 'EditNoDocumento';
    EditNoDocumento.Left := 204;
    EditNoDocumento.Top := 123;
    EditNoDocumento.Width := 106;
    EditNoDocumento.Height := 22;
    EditNoDocumento.CharCase := wecUpperCase;
    EditNoDocumento.ChildOrder := 1;
    EditNoDocumento.Font.Charset := ANSI_CHARSET;
    EditNoDocumento.Font.Color := clWindowText;
    EditNoDocumento.Font.Height := -12;
    EditNoDocumento.Font.Name := 'Book Antiqua';
    EditNoDocumento.Font.Style := [];
    EditNoDocumento.HeightPercent := 100.000000000000000000;
    EditNoDocumento.ParentFont := False;
    EditNoDocumento.WidthPercent := 100.000000000000000000;
    EditNoDocumento.DataField := 'NoDocumento';
    EditNoDocumento.DataSource := DsSolicitudHdr;
    EditAlcance.SetParentComponent(WPanel3);
    EditAlcance.Name := 'EditAlcance';
    EditAlcance.Left := 69;
    EditAlcance.Top := 244;
    EditAlcance.Width := 367;
    EditAlcance.Height := 22;
    EditAlcance.CharCase := wecUpperCase;
    EditAlcance.ChildOrder := 1;
    EditAlcance.Font.Charset := ANSI_CHARSET;
    EditAlcance.Font.Color := clWindowText;
    EditAlcance.Font.Height := -12;
    EditAlcance.Font.Name := 'Book Antiqua';
    EditAlcance.Font.Style := [];
    EditAlcance.HeightPercent := 100.000000000000000000;
    EditAlcance.ParentFont := False;
    EditAlcance.WidthPercent := 100.000000000000000000;
    EditAlcance.DataField := 'Alcance';
    EditAlcance.DataSource := DsSolicitudHdr;
    EditFechaFinalizada.SetParentComponent(WPanel3);
    EditFechaFinalizada.Name := 'EditFechaFinalizada';
    EditFechaFinalizada.Left := 368;
    EditFechaFinalizada.Top := 47;
    EditFechaFinalizada.Width := 121;
    EditFechaFinalizada.Height := 22;
    EditFechaFinalizada.CharCase := wecUpperCase;
    EditFechaFinalizada.ChildOrder := 1;
    EditFechaFinalizada.Font.Charset := ANSI_CHARSET;
    EditFechaFinalizada.Font.Color := clWindowText;
    EditFechaFinalizada.Font.Height := -12;
    EditFechaFinalizada.Font.Name := 'Book Antiqua';
    EditFechaFinalizada.Font.Style := [];
    EditFechaFinalizada.HeightPercent := 100.000000000000000000;
    EditFechaFinalizada.ParentFont := False;
    EditFechaFinalizada.WidthPercent := 100.000000000000000000;
    SetEvent(EditFechaFinalizada, Self, 'OnEnter', 'EditFechaFinalizadaEnter');
    EditFechaFinalizada.DataField := 'FechaFinalizada';
    EditFechaFinalizada.DataSource := DsSolicitudHdr;
    EditOnClass.SetParentComponent(WPanel3);
    EditOnClass.Name := 'EditOnClass';
    EditOnClass.Left := 137;
    EditOnClass.Top := 306;
    EditOnClass.Width := 33;
    EditOnClass.Height := 22;
    EditOnClass.CharCase := wecUpperCase;
    EditOnClass.ChildOrder := 1;
    EditOnClass.Font.Charset := ANSI_CHARSET;
    EditOnClass.Font.Color := clWindowText;
    EditOnClass.Font.Height := -12;
    EditOnClass.Font.Name := 'Book Antiqua';
    EditOnClass.Font.Style := [];
    EditOnClass.HeightPercent := 100.000000000000000000;
    EditOnClass.ParentFont := False;
    EditOnClass.WidthPercent := 100.000000000000000000;
    EditOnClass.DataField := 'OnClass';
    EditOnClass.DataSource := DsSolicitudHdr;
    EditOnDem.SetParentComponent(WPanel3);
    EditOnDem.Name := 'EditOnDem';
    EditOnDem.Left := 137;
    EditOnDem.Top := 330;
    EditOnDem.Width := 33;
    EditOnDem.Height := 22;
    EditOnDem.CharCase := wecUpperCase;
    EditOnDem.ChildOrder := 1;
    EditOnDem.Font.Charset := ANSI_CHARSET;
    EditOnDem.Font.Color := clWindowText;
    EditOnDem.Font.Height := -12;
    EditOnDem.Font.Name := 'Book Antiqua';
    EditOnDem.Font.Style := [];
    EditOnDem.HeightPercent := 100.000000000000000000;
    EditOnDem.ParentFont := False;
    EditOnDem.WidthPercent := 100.000000000000000000;
    EditOnDem.DataField := 'OnDem';
    EditOnDem.DataSource := DsSolicitudHdr;
    EditOnJob.SetParentComponent(WPanel3);
    EditOnJob.Name := 'EditOnJob';
    EditOnJob.Left := 137;
    EditOnJob.Top := 354;
    EditOnJob.Width := 33;
    EditOnJob.Height := 22;
    EditOnJob.CharCase := wecUpperCase;
    EditOnJob.ChildOrder := 1;
    EditOnJob.Font.Charset := ANSI_CHARSET;
    EditOnJob.Font.Color := clWindowText;
    EditOnJob.Font.Height := -12;
    EditOnJob.Font.Name := 'Book Antiqua';
    EditOnJob.Font.Style := [];
    EditOnJob.HeightPercent := 100.000000000000000000;
    EditOnJob.ParentFont := False;
    EditOnJob.WidthPercent := 100.000000000000000000;
    EditOnJob.DataField := 'OnJob';
    EditOnJob.DataSource := DsSolicitudHdr;
    EditOnVideo.SetParentComponent(WPanel3);
    EditOnVideo.Name := 'EditOnVideo';
    EditOnVideo.Left := 137;
    EditOnVideo.Top := 378;
    EditOnVideo.Width := 33;
    EditOnVideo.Height := 22;
    EditOnVideo.CharCase := wecUpperCase;
    EditOnVideo.ChildOrder := 1;
    EditOnVideo.Font.Charset := ANSI_CHARSET;
    EditOnVideo.Font.Color := clWindowText;
    EditOnVideo.Font.Height := -12;
    EditOnVideo.Font.Name := 'Book Antiqua';
    EditOnVideo.Font.Style := [];
    EditOnVideo.HeightPercent := 100.000000000000000000;
    EditOnVideo.ParentFont := False;
    EditOnVideo.WidthPercent := 100.000000000000000000;
    EditOnVideo.DataField := 'OnVideo';
    EditOnVideo.DataSource := DsSolicitudHdr;
    EditOnSemin.SetParentComponent(WPanel3);
    EditOnSemin.Name := 'EditOnSemin';
    EditOnSemin.Left := 305;
    EditOnSemin.Top := 306;
    EditOnSemin.Width := 33;
    EditOnSemin.Height := 22;
    EditOnSemin.CharCase := wecUpperCase;
    EditOnSemin.ChildOrder := 1;
    EditOnSemin.Font.Charset := ANSI_CHARSET;
    EditOnSemin.Font.Color := clWindowText;
    EditOnSemin.Font.Height := -12;
    EditOnSemin.Font.Name := 'Book Antiqua';
    EditOnSemin.Font.Style := [];
    EditOnSemin.HeightPercent := 100.000000000000000000;
    EditOnSemin.ParentFont := False;
    EditOnSemin.WidthPercent := 100.000000000000000000;
    EditOnSemin.DataField := 'OnSemin';
    EditOnSemin.DataSource := DsSolicitudHdr;
    EditOnSelf.SetParentComponent(WPanel3);
    EditOnSelf.Name := 'EditOnSelf';
    EditOnSelf.Left := 305;
    EditOnSelf.Top := 330;
    EditOnSelf.Width := 33;
    EditOnSelf.Height := 22;
    EditOnSelf.CharCase := wecUpperCase;
    EditOnSelf.ChildOrder := 1;
    EditOnSelf.Font.Charset := ANSI_CHARSET;
    EditOnSelf.Font.Color := clWindowText;
    EditOnSelf.Font.Height := -12;
    EditOnSelf.Font.Name := 'Book Antiqua';
    EditOnSelf.Font.Style := [];
    EditOnSelf.HeightPercent := 100.000000000000000000;
    EditOnSelf.ParentFont := False;
    EditOnSelf.WidthPercent := 100.000000000000000000;
    EditOnSelf.DataField := 'OnSelf';
    EditOnSelf.DataSource := DsSolicitudHdr;
    EditOnOther.SetParentComponent(WPanel3);
    EditOnOther.Name := 'EditOnOther';
    EditOnOther.Left := 305;
    EditOnOther.Top := 354;
    EditOnOther.Width := 179;
    EditOnOther.Height := 22;
    EditOnOther.CharCase := wecUpperCase;
    EditOnOther.ChildOrder := 1;
    EditOnOther.Font.Charset := ANSI_CHARSET;
    EditOnOther.Font.Color := clWindowText;
    EditOnOther.Font.Height := -12;
    EditOnOther.Font.Name := 'Book Antiqua';
    EditOnOther.Font.Style := [];
    EditOnOther.HeightPercent := 100.000000000000000000;
    EditOnOther.ParentFont := False;
    EditOnOther.WidthPercent := 100.000000000000000000;
    EditOnOther.DataField := 'OnOther';
    EditOnOther.DataSource := DsSolicitudHdr;
    EditDuracion.SetParentComponent(WPanel3);
    EditDuracion.Name := 'EditDuracion';
    EditDuracion.Left := 481;
    EditDuracion.Top := 302;
    EditDuracion.Width := 84;
    EditDuracion.Height := 22;
    EditDuracion.CharCase := wecUpperCase;
    EditDuracion.ChildOrder := 1;
    EditDuracion.Font.Charset := ANSI_CHARSET;
    EditDuracion.Font.Color := clWindowText;
    EditDuracion.Font.Height := -12;
    EditDuracion.Font.Name := 'Book Antiqua';
    EditDuracion.Font.Style := [];
    EditDuracion.HeightPercent := 100.000000000000000000;
    EditDuracion.ParentFont := False;
    EditDuracion.WidthPercent := 100.000000000000000000;
    EditDuracion.DataField := 'Duracion';
    EditDuracion.DataSource := DsSolicitudHdr;
    EditDuracionTotal.SetParentComponent(WPanel3);
    EditDuracionTotal.Name := 'EditDuracionTotal';
    EditDuracionTotal.Left := 481;
    EditDuracionTotal.Top := 326;
    EditDuracionTotal.Width := 84;
    EditDuracionTotal.Height := 22;
    EditDuracionTotal.CharCase := wecUpperCase;
    EditDuracionTotal.ChildOrder := 1;
    EditDuracionTotal.Font.Charset := ANSI_CHARSET;
    EditDuracionTotal.Font.Color := clWindowText;
    EditDuracionTotal.Font.Height := -12;
    EditDuracionTotal.Font.Name := 'Book Antiqua';
    EditDuracionTotal.Font.Style := [];
    EditDuracionTotal.HeightPercent := 100.000000000000000000;
    EditDuracionTotal.ParentFont := False;
    EditDuracionTotal.WidthPercent := 100.000000000000000000;
    EditDuracionTotal.DataField := 'DuracionTotal';
    EditDuracionTotal.DataSource := DsSolicitudHdr;
    WebDateTimePicker1.SetParentComponent(WPanel3);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 522;
    WebDateTimePicker1.Top := 53;
    WebDateTimePicker1.Width := 170;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.HeightPercent := 100.000000000000000000;
    WebDateTimePicker1.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 43;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 45875.649133333330000000;
    WebDateTimePicker1.Font.Charset := ANSI_CHARSET;
    WebDateTimePicker1.Font.Color := clWindowText;
    WebDateTimePicker1.Font.Height := -12;
    WebDateTimePicker1.Font.Name := 'Book Antiqua';
    WebDateTimePicker1.Font.Style := [];
    WebDateTimePicker1.ParentFont := False;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    SetEvent(WebDateTimePicker1, Self, 'OnExit', 'WebDateTimePicker1Exit');
    WebDateTimePicker2.SetParentComponent(WPanel3);
    WebDateTimePicker2.Name := 'WebDateTimePicker2';
    WebDateTimePicker2.Left := 522;
    WebDateTimePicker2.Top := 77;
    WebDateTimePicker2.Width := 170;
    WebDateTimePicker2.Height := 22;
    WebDateTimePicker2.HeightPercent := 100.000000000000000000;
    WebDateTimePicker2.WidthPercent := 100.000000000000000000;
    WebDateTimePicker2.BorderStyle := bsSingle;
    WebDateTimePicker2.ChildOrder := 43;
    WebDateTimePicker2.Color := clWhite;
    WebDateTimePicker2.Date := 45875.649133333330000000;
    WebDateTimePicker2.Font.Charset := ANSI_CHARSET;
    WebDateTimePicker2.Font.Color := clWindowText;
    WebDateTimePicker2.Font.Height := -12;
    WebDateTimePicker2.Font.Name := 'Book Antiqua';
    WebDateTimePicker2.Font.Style := [];
    WebDateTimePicker2.ParentFont := False;
    WebDateTimePicker2.Role := '';
    WebDateTimePicker2.Text := '';
    SetEvent(WebDateTimePicker2, Self, 'OnExit', 'WebDateTimePicker2Exit');
    WebSpeedButton9.SetParentComponent(WPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 755;
    WebSpeedButton9.Top := 27;
    WebSpeedButton9.Width := 70;
    WebSpeedButton9.Height := 66;
    WebSpeedButton9.Hint := 'Aceptar la captura';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.Glyph.LoadFromFile('Menu.WPanel3.WebSpeedButton9.Glyph.bmp');
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.ShowHint := True;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(WPanel3);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 851;
    WebSpeedButton10.Top := 24;
    WebSpeedButton10.Width := 73;
    WebSpeedButton10.Height := 72;
    WebSpeedButton10.Hint := 'Ignorar la captura';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('Menu.WPanel3.WebSpeedButton10.Glyph.bmp');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.ShowHint := True;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebPanel1.SetParentComponent(WebPageControl1Sheet1);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 3;
    WebPanel1.Top := 4;
    WebPanel1.Width := 942;
    WebPanel1.Height := 99;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clSilver;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ChildOrder := 1;
    WebLabel33.SetParentComponent(WebPanel1);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 432;
    WebLabel33.Top := 5;
    WebLabel33.Width := 64;
    WebLabel33.Height := 16;
    WebLabel33.Caption := 'Buscar folio';
    WebLabel33.HeightPercent := 100.000000000000000000;
    WebLabel33.WidthPercent := 100.000000000000000000;
    EditBuscar.SetParentComponent(WebPanel1);
    EditBuscar.Name := 'EditBuscar';
    EditBuscar.Left := 422;
    EditBuscar.Top := 19;
    EditBuscar.Width := 121;
    EditBuscar.Height := 24;
    EditBuscar.ChildOrder := 4;
    EditBuscar.Font.Charset := ANSI_CHARSET;
    EditBuscar.Font.Color := clWindowText;
    EditBuscar.Font.Height := -12;
    EditBuscar.Font.Name := 'Book Antiqua';
    EditBuscar.Font.Style := [];
    EditBuscar.HeightPercent := 100.000000000000000000;
    EditBuscar.ParentFont := False;
    EditBuscar.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel1);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 6;
    WebSpeedButton3.Top := 4;
    WebSpeedButton3.Width := 63;
    WebSpeedButton3.Height := 62;
    WebSpeedButton3.Hint := 'Agregar documento';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('Menu.WebPanel1.WebSpeedButton3.Glyph.bmp');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.ShowHint := True;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel1);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 96;
    WebSpeedButton4.Top := 3;
    WebSpeedButton4.Width := 66;
    WebSpeedButton4.Height := 67;
    WebSpeedButton4.Hint := 'Modificar documento';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('Menu.WebPanel1.WebSpeedButton4.Glyph.bmp');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.ShowHint := True;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(WebPanel1);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 192;
    WebSpeedButton5.Top := 6;
    WebSpeedButton5.Width := 57;
    WebSpeedButton5.Height := 65;
    WebSpeedButton5.Hint := 'Borrar documento';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('Menu.WebPanel1.WebSpeedButton5.Glyph.bmp');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.ShowHint := True;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebSpeedButton6.SetParentComponent(WebPanel1);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 558;
    WebSpeedButton6.Top := 3;
    WebSpeedButton6.Width := 59;
    WebSpeedButton6.Height := 67;
    WebSpeedButton6.Hint := 'Buscar un documento';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('Menu.WebPanel1.WebSpeedButton6.Glyph.bmp');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.ShowHint := True;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel1);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 876;
    WebSpeedButton7.Top := 1;
    WebSpeedButton7.Width := 60;
    WebSpeedButton7.Height := 70;
    WebSpeedButton7.Hint := 'Regresar al menu principal';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.Glyph.LoadFromFile('Menu.WebPanel1.WebSpeedButton7.Glyph.bmp');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.ShowHint := True;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebDBGrid1.SetParentComponent(WebPageControl1Sheet1);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 2;
    WebDBGrid1.Top := 518;
    WebDBGrid1.Width := 942;
    WebDBGrid1.Height := 146;
    WebDBGrid1.Color := 15400959;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Folio';
      Title := 'Folio';
      Width := 80;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'FechaPedido';
      Title := 'Fecha';
      Width := 120;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre';
      Title := 'Solicit'#243;
      Width := 163;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre2';
      Title := 'A quien Solit'#243;
      Width := 263;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'NoDocumento';
      Title := 'NoDocumento';
      Width := 110;
    end;
    WebDBGrid1.DataSource := DsSolicitudHdr;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.Font.Charset := ANSI_CHARSET;
    WebDBGrid1.Font.Color := clWindowText;
    WebDBGrid1.Font.Height := -12;
    WebDBGrid1.Font.Name := 'Book Antiqua';
    WebDBGrid1.Font.Style := [];
    WebDBGrid1.ParentFont := False;
    WebDBGrid1.TabOrder := 2;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 80;
    WebDBGrid1.ColWidths[2] := 120;
    WebDBGrid1.ColWidths[3] := 163;
    WebDBGrid1.ColWidths[4] := 263;
    WebDBGrid1.ColWidths[5] := 110;
    Empleados.SetParentComponent(WebPageControl1);
    Empleados.Name := 'Empleados';
    Empleados.Left := 0;
    Empleados.Top := 20;
    Empleados.Width := 988;
    Empleados.Height := 698;
    Empleados.HeightPercent := 100.000000000000000000;
    Empleados.WidthPercent := 100.000000000000000000;
    Empleados.Caption := '  EMPLEADOS';
    Empleados.ChildOrder := 1;
    Empleados.Color := 15794145;
    SetEvent(Empleados, Self, 'OnShow', 'EmpleadosShow');
    WebPanel2.SetParentComponent(Empleados);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 15;
    WebPanel2.Top := 12;
    WebPanel2.Width := 874;
    WebPanel2.Height := 105;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clSilver;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.ChildOrder := 1;
    WebSpeedButton11.SetParentComponent(WebPanel2);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 8;
    WebSpeedButton11.Top := 16;
    WebSpeedButton11.Width := 63;
    WebSpeedButton11.Height := 81;
    WebSpeedButton11.Hint := 'Agrerar a un empleado al documento';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('Menu.WebPanel2.WebSpeedButton11.Glyph.bmp');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.ShowHint := True;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton12.SetParentComponent(WebPanel2);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 100;
    WebSpeedButton12.Top := 16;
    WebSpeedButton12.Width := 89;
    WebSpeedButton12.Height := 80;
    WebSpeedButton12.Hint := 'Modificar un empleado';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.Glyph.LoadFromFile('Menu.WebPanel2.WebSpeedButton12.Glyph.bmp');
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.ShowHint := True;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    WebSpeedButton13.SetParentComponent(WebPanel2);
    WebSpeedButton13.Name := 'WebSpeedButton13';
    WebSpeedButton13.Left := 224;
    WebSpeedButton13.Top := 18;
    WebSpeedButton13.Width := 74;
    WebSpeedButton13.Height := 73;
    WebSpeedButton13.Hint := 'Borrar el empleado';
    WebSpeedButton13.Color := clNone;
    WebSpeedButton13.Glyph.LoadFromFile('Menu.WebPanel2.WebSpeedButton13.Glyph.bmp');
    WebSpeedButton13.HeightPercent := 100.000000000000000000;
    WebSpeedButton13.ShowHint := True;
    WebSpeedButton13.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton13, Self, 'OnClick', 'WebSpeedButton13Click');
    WebSpeedButton14.SetParentComponent(WebPanel2);
    WebSpeedButton14.Name := 'WebSpeedButton14';
    WebSpeedButton14.Left := 784;
    WebSpeedButton14.Top := 16;
    WebSpeedButton14.Width := 73;
    WebSpeedButton14.Height := 77;
    WebSpeedButton14.Hint := 'Regresar al documento';
    WebSpeedButton14.Color := clNone;
    WebSpeedButton14.Glyph.LoadFromFile('Menu.WebPanel2.WebSpeedButton14.Glyph.bmp');
    WebSpeedButton14.HeightPercent := 100.000000000000000000;
    WebSpeedButton14.ShowHint := True;
    WebSpeedButton14.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton14, Self, 'OnClick', 'WebSpeedButton14Click');
    WebPanel3.SetParentComponent(Empleados);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 15;
    WebPanel3.Top := 120;
    WebPanel3.Width := 817;
    WebPanel3.Height := 220;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clSilver;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := 16775408;
    WebLabel21.SetParentComponent(WebPanel3);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 24;
    WebLabel21.Top := 35;
    WebLabel21.Width := 122;
    WebLabel21.Height := 16;
    WebLabel21.Caption := 'Numero de empleado:';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(WebPanel3);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 14;
    WebLabel22.Top := 81;
    WebLabel22.Width := 126;
    WebLabel22.Height := 16;
    WebLabel22.Caption := 'Nombre del empleado:';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(WebPanel3);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 78;
    WebLabel23.Top := 105;
    WebLabel23.Width := 39;
    WebLabel23.Height := 16;
    WebLabel23.Caption := 'Puesto:';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel34.SetParentComponent(WebPanel3);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 105;
    WebLabel34.Top := 10;
    WebLabel34.Width := 32;
    WebLabel34.Height := 16;
    WebLabel34.Caption := 'Folio:';
    WebLabel34.HeightPercent := 100.000000000000000000;
    WebLabel34.WidthPercent := 100.000000000000000000;
    EditNumero.SetParentComponent(WebPanel3);
    EditNumero.Name := 'EditNumero';
    EditNumero.Left := 152;
    EditNumero.Top := 32;
    EditNumero.Width := 121;
    EditNumero.Height := 22;
    EditNumero.CharCase := wecUpperCase;
    EditNumero.ChildOrder := 1;
    EditNumero.HeightPercent := 100.000000000000000000;
    EditNumero.WidthPercent := 100.000000000000000000;
    EditNumero.DataField := 'Numero';
    EditNumero.DataSource := DsSolicitudDet;
    EditEmpPaterno.SetParentComponent(WebPanel3);
    EditEmpPaterno.Name := 'EditEmpPaterno';
    EditEmpPaterno.Left := 147;
    EditEmpPaterno.Top := 78;
    EditEmpPaterno.Width := 121;
    EditEmpPaterno.Height := 22;
    EditEmpPaterno.CharCase := wecUpperCase;
    EditEmpPaterno.ChildOrder := 1;
    EditEmpPaterno.HeightPercent := 100.000000000000000000;
    EditEmpPaterno.WidthPercent := 100.000000000000000000;
    EditEmpPaterno.DataField := 'empPaterno';
    EditEmpPaterno.DataSource := DsSolicitudDet;
    EditEmpMaterno.SetParentComponent(WebPanel3);
    EditEmpMaterno.Name := 'EditEmpMaterno';
    EditEmpMaterno.Left := 274;
    EditEmpMaterno.Top := 78;
    EditEmpMaterno.Width := 121;
    EditEmpMaterno.Height := 22;
    EditEmpMaterno.CharCase := wecUpperCase;
    EditEmpMaterno.ChildOrder := 1;
    EditEmpMaterno.HeightPercent := 100.000000000000000000;
    EditEmpMaterno.WidthPercent := 100.000000000000000000;
    EditEmpMaterno.DataField := 'EmpMaterno';
    EditEmpMaterno.DataSource := DsSolicitudDet;
    EditEmpNombre.SetParentComponent(WebPanel3);
    EditEmpNombre.Name := 'EditEmpNombre';
    EditEmpNombre.Left := 398;
    EditEmpNombre.Top := 78;
    EditEmpNombre.Width := 121;
    EditEmpNombre.Height := 22;
    EditEmpNombre.CharCase := wecUpperCase;
    EditEmpNombre.ChildOrder := 1;
    EditEmpNombre.HeightPercent := 100.000000000000000000;
    EditEmpNombre.WidthPercent := 100.000000000000000000;
    EditEmpNombre.DataField := 'EmpNombre';
    EditEmpNombre.DataSource := DsSolicitudDet;
    EditPuesto.SetParentComponent(WebPanel3);
    EditPuesto.Name := 'EditPuesto';
    EditPuesto.Left := 147;
    EditPuesto.Top := 102;
    EditPuesto.Width := 68;
    EditPuesto.Height := 22;
    EditPuesto.CharCase := wecUpperCase;
    EditPuesto.ChildOrder := 1;
    EditPuesto.HeightPercent := 100.000000000000000000;
    EditPuesto.WidthPercent := 100.000000000000000000;
    EditPuesto.DataField := 'Puesto';
    EditPuesto.DataSource := DsSolicitudDet;
    EditPuestoNombre.SetParentComponent(WebPanel3);
    EditPuestoNombre.Name := 'EditPuestoNombre';
    EditPuestoNombre.Left := 223;
    EditPuestoNombre.Top := 102;
    EditPuestoNombre.Width := 262;
    EditPuestoNombre.Height := 22;
    EditPuestoNombre.CharCase := wecUpperCase;
    EditPuestoNombre.ChildOrder := 1;
    EditPuestoNombre.HeightPercent := 100.000000000000000000;
    EditPuestoNombre.WidthPercent := 100.000000000000000000;
    EditPuestoNombre.DataField := 'Puestonombre';
    EditPuestoNombre.DataSource := DsSolicitudDet;
    EditFolioD.SetParentComponent(WebPanel3);
    EditFolioD.Name := 'EditFolioD';
    EditFolioD.Left := 153;
    EditFolioD.Top := 7;
    EditFolioD.Width := 121;
    EditFolioD.Height := 22;
    EditFolioD.CharCase := wecUpperCase;
    EditFolioD.ChildOrder := 1;
    EditFolioD.HeightPercent := 100.000000000000000000;
    EditFolioD.WidthPercent := 100.000000000000000000;
    EditFolioD.DataField := 'Folio';
    EditFolioD.DataSource := DsSolicitudDet;
    WebSpeedButton15.SetParentComponent(WebPanel3);
    WebSpeedButton15.Name := 'WebSpeedButton15';
    WebSpeedButton15.Left := 603;
    WebSpeedButton15.Top := 22;
    WebSpeedButton15.Width := 70;
    WebSpeedButton15.Height := 66;
    WebSpeedButton15.Hint := 'Aceptar la captura';
    WebSpeedButton15.Color := clNone;
    WebSpeedButton15.Glyph.LoadFromFile('Menu.WebPanel3.WebSpeedButton15.Glyph.bmp');
    WebSpeedButton15.HeightPercent := 100.000000000000000000;
    WebSpeedButton15.ShowHint := True;
    WebSpeedButton15.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton15, Self, 'OnClick', 'WebSpeedButton15Click');
    WebSpeedButton16.SetParentComponent(WebPanel3);
    WebSpeedButton16.Name := 'WebSpeedButton16';
    WebSpeedButton16.Left := 712;
    WebSpeedButton16.Top := 22;
    WebSpeedButton16.Width := 73;
    WebSpeedButton16.Height := 72;
    WebSpeedButton16.Hint := 'Ignorar la captura';
    WebSpeedButton16.Color := clNone;
    WebSpeedButton16.Glyph.LoadFromFile('Menu.WebPanel3.WebSpeedButton16.Glyph.bmp');
    WebSpeedButton16.HeightPercent := 100.000000000000000000;
    WebSpeedButton16.ShowHint := True;
    WebSpeedButton16.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton16, Self, 'OnClick', 'WebSpeedButton16Click');
    WebSpeedButton17.SetParentComponent(WebPanel3);
    WebSpeedButton17.Name := 'WebSpeedButton17';
    WebSpeedButton17.Left := 286;
    WebSpeedButton17.Top := 5;
    WebSpeedButton17.Width := 59;
    WebSpeedButton17.Height := 67;
    WebSpeedButton17.Hint := 'Busar al empleado y llenar datos de nombre etc...';
    WebSpeedButton17.Color := clNone;
    WebSpeedButton17.Glyph.LoadFromFile('Menu.WebPanel3.WebSpeedButton17.Glyph.bmp');
    WebSpeedButton17.HeightPercent := 100.000000000000000000;
    WebSpeedButton17.ShowHint := True;
    WebSpeedButton17.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton17, Self, 'OnClick', 'WebSpeedButton17Click');
    WebDBGrid2.SetParentComponent(Empleados);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 15;
    WebDBGrid2.Top := 341;
    WebDBGrid2.Width := 817;
    WebDBGrid2.Height := 146;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Folio';
      Title := 'Folio';
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Numero';
      Title := 'No.Empleado';
      Width := 76;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'EmpPaterno';
      Title := 'Paterno';
      Width := 163;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'EmpMaterno';
      Title := 'Materno';
      Width := 237;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'EmpNombre';
      Title := 'Nombre';
      Width := 140;
    end;
    WebDBGrid2.DataSource := DsSolicitudDet;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.Font.Charset := ANSI_CHARSET;
    WebDBGrid2.Font.Color := clWindowText;
    WebDBGrid2.Font.Height := -12;
    WebDBGrid2.Font.Name := 'Book Antiqua';
    WebDBGrid2.Font.Style := [];
    WebDBGrid2.ParentFont := False;
    WebDBGrid2.TabOrder := 2;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 64;
    WebDBGrid2.ColWidths[2] := 76;
    WebDBGrid2.ColWidths[3] := 163;
    WebDBGrid2.ColWidths[4] := 237;
    WebDBGrid2.ColWidths[5] := 140;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    WebHttpRequest1.Left := 448;
    WebHttpRequest1.Top := 16;
    ConSolicitudHdr.SetParentComponent(Self);
    ConSolicitudHdr.Name := 'ConSolicitudHdr';
    ConSolicitudHdr.Active := False;
    ConSolicitudHdr.URI := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudHDR?Usuario=ADMINALL&Clave=ADdd11NALL9087726';
    ConSolicitudHdr.Left := 640;
    ConSolicitudHdr.Top := 16;
    TSolicitudHdr.SetParentComponent(Self);
    TSolicitudHdr.Name := 'TSolicitudHdr';
    TSolicitudHdr.Active := True;
    TSolicitudHdr.Connection := ConSolicitudHdr;
    SetEvent(TSolicitudHdr, Self, 'OnCalcFields', 'TSolicitudHdrCalcFields');
    TSolicitudHdr.Left := 768;
    TSolicitudHdr.Top := 16;
    DsSolicitudHdr.SetParentComponent(Self);
    DsSolicitudHdr.Name := 'DsSolicitudHdr';
    DsSolicitudHdr.DataSet := TSolicitudHdr;
    DsSolicitudHdr.Left := 864;
    DsSolicitudHdr.Top := 24;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    WebTimer1.Interval := 200;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 952;
    WebTimer1.Top := 16;
    ConSolicitudDET.SetParentComponent(Self);
    ConSolicitudDET.Name := 'ConSolicitudDET';
    ConSolicitudDET.Active := False;
    ConSolicitudDET.URI := 'https://begins-builder-allied-strength.trycloudflare.com/SolicitudDET?Usuario=ADMINALL&Clave=ADdd11NALL9087726';
    ConSolicitudDET.Left := 640;
    ConSolicitudDET.Top := 69;
    TSolicitudDet.SetParentComponent(Self);
    TSolicitudDet.Name := 'TSolicitudDet';
    TSolicitudDet.Active := True;
    TSolicitudDet.Connection := ConSolicitudDET;
    TSolicitudDet.Left := 768;
    TSolicitudDet.Top := 73;
    DsSolicitudDet.SetParentComponent(Self);
    DsSolicitudDet.Name := 'DsSolicitudDet';
    DsSolicitudDet.DataSet := TSolicitudDet;
    DsSolicitudDet.Left := 864;
    DsSolicitudDet.Top := 80;
    WebTimer2.SetParentComponent(Self);
    WebTimer2.Name := 'WebTimer2';
    WebTimer2.Enabled := False;
    WebTimer2.Interval := 200;
    SetEvent(WebTimer2, Self, 'OnTimer', 'WebTimer2Timer');
    WebTimer2.Left := 960;
    WebTimer2.Top := 72;
    ConEmpleados.SetParentComponent(Self);
    ConEmpleados.Name := 'ConEmpleados';
    ConEmpleados.Active := False;
    ConEmpleados.URI := 'https://begins-builder-allied-strength.trycloudflare.com/Empleados?Usuario=ADMINALL&Clave=ADdd11NALL9087726';
    ConEmpleados.Left := 640;
    ConEmpleados.Top := 129;
    TEmpleados.SetParentComponent(Self);
    TEmpleados.Name := 'TEmpleados';
    TEmpleados.Active := True;
    TEmpleados.Connection := ConEmpleados;
    TEmpleados.Left := 712;
    TEmpleados.Top := 131;
    DSEmpleados.SetParentComponent(Self);
    DSEmpleados.Name := 'DSEmpleados';
    DSEmpleados.DataSet := TEmpleados;
    DSEmpleados.Left := 781;
    DSEmpleados.Top := 131;
    ConUsuarios.SetParentComponent(Self);
    ConUsuarios.Name := 'ConUsuarios';
    ConUsuarios.Active := False;
    ConUsuarios.URI := 'https://begins-builder-allied-strength.trycloudflare.com/Usuarios';
    ConUsuarios.Left := 640;
    ConUsuarios.Top := 185;
    TUsuarios.SetParentComponent(Self);
    TUsuarios.Name := 'TUsuarios';
    TUsuarios.Active := True;
    TUsuarios.Connection := ConUsuarios;
    TUsuarios.Left := 720;
    TUsuarios.Top := 179;
    ConPuestos.SetParentComponent(Self);
    ConPuestos.Name := 'ConPuestos';
    ConPuestos.Active := False;
    ConPuestos.URI := 'https://begins-builder-allied-strength.trycloudflare.com/Puestos?Usuario=ADMINALL&Clave=ADdd11NALL9087726';
    ConPuestos.Left := 640;
    ConPuestos.Top := 241;
    TPuestos.SetParentComponent(Self);
    TPuestos.Name := 'TPuestos';
    TPuestos.Active := True;
    TPuestos.Connection := ConPuestos;
    TPuestos.Left := 728;
    TPuestos.Top := 243;
  finally
    WebImageControl1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WPanel1.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    EditUsuario.AfterLoadDFMValues;
    EditClave.AfterLoadDFMValues;
    WPanel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    EditFolioi.AfterLoadDFMValues;
    WebSpeedButton18.AfterLoadDFMValues;
    WebSpeedButton19.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WPanel3.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    EditFolio.AfterLoadDFMValues;
    EditFechaPedido.AfterLoadDFMValues;
    EditNombre.AfterLoadDFMValues;
    EditNombre2.AfterLoadDFMValues;
    EditDepto.AfterLoadDFMValues;
    EditDepto2.AfterLoadDFMValues;
    EditDocumentoNombre.AfterLoadDFMValues;
    EditRevision.AfterLoadDFMValues;
    EditNoDocumento.AfterLoadDFMValues;
    EditAlcance.AfterLoadDFMValues;
    EditFechaFinalizada.AfterLoadDFMValues;
    EditOnClass.AfterLoadDFMValues;
    EditOnDem.AfterLoadDFMValues;
    EditOnJob.AfterLoadDFMValues;
    EditOnVideo.AfterLoadDFMValues;
    EditOnSemin.AfterLoadDFMValues;
    EditOnSelf.AfterLoadDFMValues;
    EditOnOther.AfterLoadDFMValues;
    EditDuracion.AfterLoadDFMValues;
    EditDuracionTotal.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    WebDateTimePicker2.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    EditBuscar.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    Empleados.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    WebSpeedButton13.AfterLoadDFMValues;
    WebSpeedButton14.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    EditNumero.AfterLoadDFMValues;
    EditEmpPaterno.AfterLoadDFMValues;
    EditEmpMaterno.AfterLoadDFMValues;
    EditEmpNombre.AfterLoadDFMValues;
    EditPuesto.AfterLoadDFMValues;
    EditPuestoNombre.AfterLoadDFMValues;
    EditFolioD.AfterLoadDFMValues;
    WebSpeedButton15.AfterLoadDFMValues;
    WebSpeedButton16.AfterLoadDFMValues;
    WebSpeedButton17.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    ConSolicitudHdr.AfterLoadDFMValues;
    TSolicitudHdr.AfterLoadDFMValues;
    DsSolicitudHdr.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    ConSolicitudDET.AfterLoadDFMValues;
    TSolicitudDet.AfterLoadDFMValues;
    DsSolicitudDet.AfterLoadDFMValues;
    WebTimer2.AfterLoadDFMValues;
    ConEmpleados.AfterLoadDFMValues;
    TEmpleados.AfterLoadDFMValues;
    DSEmpleados.AfterLoadDFMValues;
    ConUsuarios.AfterLoadDFMValues;
    TUsuarios.AfterLoadDFMValues;
    ConPuestos.AfterLoadDFMValues;
    TPuestos.AfterLoadDFMValues;
  end;
end;

end.